import TemplateView from '../../../../../../js/TemplateView'
import LoadingSpinner from '../../../../../../js/components/LoadingSpinner'

export default class FeedUrlCell extends TemplateView {
    constructor({
        onClick,
    }) {
        super()

        this.callbacks = {
            onClick,
        }

        this.state = {
            active: false,
            loading: false,
        }

        this.onStatePropertyChanged('active', (active) => {
            this.getEl().toggleClass('active', active)
        })

        this.onStatePropertyChanged('loading', (loading) => {
            this.loadingSpinner.setState({show: loading})
        })
    }

    templateHtml() {
        return `<div class='feedUrlCell'>
                    <div class='spinnerContainer'/>
                    <div class='copyLinkIcon'/>
                    <div class='copyLinkText'>
                        <%=copyLinkText%>                
                    </div>
                </div>`
    }

    afterRender() {
        this.getEl().on('click', () => this.callbacks.onClick(this.getEl()))
        this.loadingSpinner = new LoadingSpinner({
            delay: 500,
        }).init(this.find('.spinnerContainer'))
    }

    messageKeys() {
        return {
            copyLinkText: 'icalendar.page.table.copy_link',
        }
    }
}



// WEBPACK FOOTER //
// ./web/actiplans/js/icalendar/components/table/cells/FeedUrlCell.js